'use client';

import type React from 'react';

// @google/genai FIX: Updated component to accept and spread all SVG props (like x, y, width, height) to the underlying SVG element.
const LibraIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Libra</title>
    <path
      d="M15.5 15C15.5 14.7239 15.7239 14.5 16 14.5H15.9687C17.2144 13.4006 18 11.792 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10C6 11.792 6.78563 13.4006 8.03127 14.5H8C8.27614 14.5 8.5 14.7239 8.5 15C8.5 15.2761 8.27614 15.5 8 15.5H4C3.72386 15.5 3.5 15.2761 3.5 15C3.5 14.7239 3.72386 14.5 4 14.5H6.63789C5.61569 13.2832 5 11.7135 5 10C5 6.134 8.134 3 12 3C15.866 3 19 6.134 19 10C19 11.7135 18.3843 13.2832 17.3621 14.5H20C20.2761 14.5 20.5 14.7239 20.5 15C20.5 15.2761 20.2761 15.5 20 15.5H16C15.7239 15.5 15.5 15.2761 15.5 15Z"
      fill="currentColor"
    />
    <path
      d="M4 18.5C3.72386 18.5 3.5 18.7239 3.5 19C3.5 19.2761 3.72386 19.5 4 19.5H20C20.2761 19.5 20.5 19.2761 20.5 19C20.5 18.7239 20.2761 18.5 20 18.5H4Z"
      fill="currentColor"
    />
  </svg>
);

export default LibraIcon;
